"use client"
import { useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";

const tabs = [
  {
    id: "v-pills-one",
    title: "A Single Invoice Sufficient For All",
    heading: "A Single Invoice Sufficient For All",
    description1:
      "Have one invoice to take care of both managed services and Amazon Cloud hosting server. It saves you time as well billing difficulties for your website and frees more time to take care of other needs.",
    details: (
      <ul className="custLi">
        <li>There is no free trial for Amazon Web Services. You have to upgrade your basic account to get access to AWS servers.</li>
        <li>Using AWS, you’re provided configured disk sizes and pay as you use bandwidth.</li>
        <li>For every server, $0.033GB will be charged for offsite backup storage.</li>
        


      </ul>
    ),
  },
  {
    id: "v-pills-two",
    title: "Your Ally in a Rough Hosting Journey",
    heading: "Your Ally in a Rough Hosting Journey",
    subhad: "Important features that make your hosting journey an easy ride:",
    description1:
      "A well-optimized stick having a pre-configured server that meets industry requirements- It provides cache solutions you’ll enjoy as the topmost AWS cloud service offer.",
    details: (
      <ul className="custLi">
        <li>There is no free trial for Amazon Web Services. You have to upgrade your basic account to get access to AWS servers.</li>
        <li>Using AWS, you’re provided configured disk sizes and pay as you use bandwidth.</li>
        <li>For every server, $0.033GB will be charged for offsite backup storage.</li> 
      </ul>
    ),
  },

  {
    id: "v-pills-three",
    title: "High-Level Performance",
    heading: "Your Ally in a Rough Hosting Journey",
    subhad: "Important features that make your hosting journey an easy ride:",
    description1:
      "A well-optimized stick having a pre-configured server that meets industry requirements- It provides cache solutions you’ll enjoy as the topmost AWS cloud service offer.",
    details: (
      <ul className="custLi">
        <li>There is no free trial for Amazon Web Services. You have to upgrade your basic account to get access to AWS servers.</li>
        <li>Using AWS, you’re provided configured disk sizes and pay as you use bandwidth.</li>
        <li>For every server, $0.033GB will be charged for offsite backup storage.</li> 
      </ul>
    ),
  },

  {
    id: "v-pills-four",
    title: "With Only A Click, Host Limitless Applications on Managed Amazon Hosting",
    heading: "With Only A Click, Host Limitless Applications on Managed Amazon Hosting",
    description1:
      "Setup and run your WordPress, Magento and PHP software with ease using AWS hosting with unmatched flexibility.",
   descriptionlist: (
    <ul className="custLi"> 
      <li>Customer satisfaction</li>
      <li>The optimized load speed of page</li>
      <li>Empowered digital Experience</li>
      <li>Successful deployment of websites</li>
      <li>Allow your business enjoy the possibilities offered by Temok</li>
      <li>Unlimited increase without restrictions- No contract, and no credit card.</li>
    </ul>
   ),
      details: (
      <ul className="custLi">
        <li>There is no free trial for Amazon Web Services. You have to upgrade your basic account to get access to AWS servers.</li>
        <li>Using AWS, you’re provided configured disk sizes and pay as you use bandwidth.</li>
        <li>For every server, $0.033GB will be charged for offsite backup storage.</li> 
      </ul>
    ),
  },

  {
    id: "v-pills-five",
    title: "Motivated to get AWS to work for your business?",
    heading: "Motivated to get AWS to work for your business?",
    description1:
      "It’s time we consider whether the choice of managed AWS is best suited for your hosting plan.",
      descriptionlist: (
        <ul className="custLi"> 
          <li>Customer satisfaction</li>
          <li>The optimized load speed of page</li>
          <li>Empowered digital Experience</li>
          <li>Successful deployment of websites</li>
          <li>Allow your business enjoy the possibilities offered by Temok</li>
          <li>Unlimited increase without restrictions- No contract, and no credit card.</li> 
        </ul>
       ),
    details: (
      <ul className="custLi">
      <li>There is no free trial for Amazon Web Services. You have to upgrade your basic account to get access to AWS servers.</li>
      <li>Using AWS, you’re provided configured disk sizes and pay as you use bandwidth.</li>
      <li>For every server, $0.033GB will be charged for offsite backup storage.</li> 
    </ul>
    ),
  },

  {
    id: "v-pills-six",
    title: "Managed Amazon Web Services (AWS)",
    heading: "Managed Amazon Web Services (AWS)",
    subhad: "Enjoy the full potential of AWS by taking advantage of Temok’s Professionalism.",
    description1:
      "Harness Temok’s management and architecture and fully utilize the potential in AWS Having knowledge of the right time and how to utilize AWS as a significant aspect of your hosting strategy architecture and plan requires experience from which most in-house teams are not equipped with. Our professionals who are AWS-certified will implement the appropriate AWS infrastructure for you and manage it for optimal efficiency and security.",
    details: (
      <ul className="custLi">
      <li>There is no free trial for Amazon Web Services. You have to upgrade your basic account to get access to AWS servers.</li>
      <li>Using AWS, you’re provided configured disk sizes and pay as you use bandwidth.</li>
      <li>For every server, $0.033GB will be charged for offsite backup storage.</li> 
    </ul>
    ),
  },
];

const AwsHostingTabs = () => {
  const [activeTab, setActiveTab] = useState<string>(tabs[0].id);

  return (
    <div className="container">
      <div className="text-center mb-5 mt-5">
        <h4 className="fw-bold display-5 text-center textHad">
          Managed Amazon Web Services 
        </h4>
        <p className="fs-5 lh-base">
          Plans That Suits Every Need
        </p>
      </div>
      <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k!)}>
        <Row>
          <Col sm={4}>
            <Nav variant="pills" className="flex-column">
              {tabs.map(({ id, title }) => (
                <Nav.Item key={id}>
                  <Nav.Link eventKey={id}>{title}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          <Col sm={8}>
            <Tab.Content>
              {tabs.map(({ id, heading, subhad, description1, descriptionlist, details }) => (
                <Tab.Pane eventKey={id} key={id} className="text-start">
                  <h5 className="textOrange fw-bold fs-3 mt-2">{heading}</h5>
                  <p className="fs-4 textPara fw-bold">{subhad}</p>
                  <p className="fs-5 textPara">{description1}</p>
                  <div className="fs-5 textPara">{descriptionlist}</div>
                  <div className="bg-light fs-5 textPara  p-3">{details}</div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default AwsHostingTabs;
